/**
 * @desc 分页
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(params: API.report.importTaskRecord.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/importTaskRecord/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
